/*
  Calendar Drag and Drop

  Enables dragging and dropping of calendar tasks and milestones (and maybe more in the future).

  EMITTED EVENTS
    taskMoveSuccess (document) Emitted after a successful task move
      detail: {
        el:  the root element of this controller instance,
        res: the 'data' portion of the response from the server
      }
*/

import { xhrRequest, afterXhrRequest, createCustomEvent } from '../../shared/helpers';

export default class extends Controller {

  connect() {
    this.updateActivityDueDate = this.updateActivityDueDate.bind(this);
    this.setClonedEl = this.setClonedEl.bind(this);
    this.restoreOpacity = this.restoreOpacity.bind(this);

    this.dragHandler = App.DragHandler.init(this.dragContainers, {
      moves: el => el.classList.contains('cal-draggable'),
      accepts: (_, target) => target.classList.contains('cal-drop-zone'),
      copy: true,
      clonedHandler: this.setClonedEl,
      dropHandler: this.updateActivityDueDate,
      cancelHandler: this.restoreOpacity
    })
  }

  disconnect() {
    this.dragHandler.destroy();
  }

  setClonedEl(clone, original, type) {
    this.clonedEl = original;
    this.clonedEl.style.opacity = '0.4';
  }

  restoreOpacity() {
    if (this.clonedEl) this.clonedEl.style.opacity = '1';
  }

  updateActivityDueDate(el, target, source, sibling) {
    if (target && source && el) {
      const targetDate = target.dataset.date;
      const sourceDate = source.dataset.date;
      if (targetDate !== sourceDate) {
        const checkbox = el.querySelector('input[name="complete"]');
        if (checkbox && !checkbox.checked && moment(targetDate).isBefore(moment(), 'day')) {
          el.classList.add('is-late');
        } else {
          el.classList.remove('is-late');
        }
        switch(el.dataset.type) {
          case 'task':
            this.updateTask(el.dataset.url, targetDate, el, source, target);
            break;
          case 'milestone':
            this.updateMilestone(el.dataset.url, targetDate, el, source, target);
            break;
        }
      }
    } else {
      this.dragHandler.cancelDrag(true);
    }
  }

  updateMilestone(url, newDate, el, source, target) {
    xhrRequest(url, 'put', { milestone: { due_on: newDate } }).then(res => {
        this.clonedEl && this.clonedEl.parentNode.removeChild(this.clonedEl);
        afterXhrRequest(res);
      }).catch(err => {
        target.removeChild(el);
        afterXhrRequest(err.response);
      }).finally(this.restoreOpacity);
  }

  updateTask(url, newDate, el, source, target) {
    xhrRequest(url, 'put', { task: { due_at: newDate } }).then(res => {
        this.clonedEl && this.clonedEl.parentNode.removeChild(this.clonedEl);
        document.dispatchEvent(createCustomEvent('taskMoveSuccess', this.element, { res: res.data }));
        afterXhrRequest(res);
      }).catch(err => {
        target.removeChild(el);
        afterXhrRequest(err.response);
      }).finally(this.restoreOpacity);
  }

  //
  // GETTERS AND SETTERS
  //

  get containers() {
    return (this.data.get('drop-containers') || '').split(/,\s+/);
  }

  get dragContainers() {
    return this.containers.reduce((all, container) => all.concat([...document.querySelectorAll(container)]), [])
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/calendar/calendar-drag-and-drop-controller.js